module.exports = __webpack_public_path__ + "img/7@2x.9cf4dffe.png";